<template>
  <div class="app-main__inner">
    <TituloComponent icono-titulo="fas fa-pencil-alt" texto-titulo="Editar Legajo"></TituloComponent>
    <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
      <div class="row">
        <div class="col-lg-12 mb-4">
          <div class="main-card mb-3 card">
              <div class="card-body divPersona">
                  <h5 class="border-bottom"><i class="fas fa-user btn-icon-wrapper btn-icon-sm mb-2"></i> Persona</h5>
                  <div v-if="!persona.id">
                      <div class="col-12 aling-center">
                          <button type="button" class="col-12 border-0 btn-icon-vertical btn-square btn-transition btn btn-outline-primary" @click="abrirModalPersona"><i class="fas fa-user btn-icon-wrapper btn-icon-lg mb-3"></i>Agregar persona</button>
                      </div>
                  </div>
                  <div class="widget-content hoverable" v-else @click="abrirModalPersona">
                      <div class="widget-content-wrapper row">
                          <div class="widget-content-left col-12">
                              <h5 class="widget-heading text-alternate">{{persona.nombre}} {{persona.apellido}}</h5>
                              <div class="widget-subheading opacity-10 row">
                                  <span class="col-sm-auto col-12 text-alternate">
                                  N° Doc/CUIL:
                                  <b>{{persona.cuil}}</b>
                                  </span>
                                  <span class="col-sm-auto col-12 text-alternate">
                                  N° Afiliado
                                  <b>{{persona.numero_afiliado}}</b>
                                  </span>
                                  <span class="col-sm-auto col-12">
                                  Domicilio:
                                  <b>{{persona.domicilio}}</b>
                                  </span>
                                  <span class="col-sm-auto col-12">
                                  Localidad:
                                  <b>{{persona.provincia}} - {{persona.localidad}}</b>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <ModalSeleccionarPersona v-if="abrirSeleccionarPersona" @cerrarSelectPersona="abrirSeleccionarPersona = false" @selectPersona="seleccionPersona" />
          </div>
          <div class="main-card mb-3 card">
              <div class="card-body">
                  <float-label label="Numero legajo:" clase="">
                      <input id="numero" v-model="legajo.numero" inputmode="numeric" placeholder="Ingresar un numero..." type="text" class="form-control" :class="(enviado && !$v.legajo.numero.required) ? 'is-invalid' : ''" />
                      <template v-slot:validation>
                          <div class="invalid-feedback" v-if="enviado && !$v.legajo.numero.required">
                              Debe ingresar numero delegajo
                          </div>
                          <div class="invalid-feedback" v-if="enviado && !$v.legajo.numero.numeric">
                              Solo se aceptan numeros
                          </div>
                      </template>
                  </float-label>
              </div>
          </div>
          <div class="main-card mb-3 card">
            <div class="card-body">
                <h5 class="border-bottom"><i class="fas fa-briefcase btn-icon-wrapper btn-icon-sm mb-2"></i> Datos Laborales</h5>
                <div class="row pt-3">
                    <div class="col-lg-6">
                        <InpSelect url="categorias" campoMostrar="descripcion" nombreLabel="Categoria" idSelect="categoria" :valor="legajo.categoria_id" @val="legajo.categoria_id=$event" :clase="(enviado && !$v.legajo.categoria_id.required) ? 'is-invalid border border-danger' : ''"> 
                            <template v-slot:validation>
                                    <div class="invalid-feedback" v-if="enviado && !$v.legajo.categoria_id.required">
                                        Debe ingresar una categoria
                                    </div>
                            </template>
                        </InpSelect>
                    </div>
                    <div class="col-lg-6">
                        <InpSelect url="seccion" campoMostrar="descripcion" nombreLabel="Seccion" idSelect="seccion" :valor="legajo.seccion_id" @val="legajo.seccion_id=$event" :clase="(enviado && !$v.legajo.seccion_id.required) ? 'is-invalid border border-danger' : ''"> 
                            <template v-slot:validation>
                                    <div class="invalid-feedback" v-if="enviado && !$v.legajo.seccion_id.required">
                                        Debe ingresar una seccion
                                    </div>
                            </template>
                        </InpSelect>
                    </div>
                    <div class="col-lg-6">
                        <InpSelect url="cargos" nombreLabel="Cargo" campoMostrar="descripcion" idSelect="cargo" :valor="legajo.cargo_id" @val="legajo.cargo_id=$event" :clase="(enviado && !$v.legajo.cargo_id.required) ? 'is-invalid border border-danger' : ''">
                            <template v-slot:validation>
                                <div class="invalid-feedback" v-if="enviado && !$v.legajo.cargo_id.required">
                                    Debe ingresar un cargo
                                </div>
                            </template>
                        </InpSelect>
                    </div>                                        
                    <div class="col-lg-6">
                        <float-label label="Clase:" clase="">
                            <select name="clase" id="clase" class="form-control" v-model="legajo.clase">
                                <option value="Mensual" selected>Mensual</option>
                                <option value="Jornal">Jornal</option>
                            </select>
                        </float-label>
                    </div>
                    <div class="col-lg-6 my-lg-3">
                        <float-label label="Fecha de ingreso:" clase="">
                                <input type="date" name="fechaIngreso" id="fechaIngreso" v-model="legajo.fecha_ingreso" class="form-control" :class="(enviado && !$v.legajo.fecha_ingreso.required) ? 'is-invalid' : ''">
                                <template v-slot:validation>
                                        <div class="invalid-feedback" v-if="enviado && !$v.legajo.fecha_ingreso.required">
                                            Debe ingresar una fecha ingreso
                                        </div>
                                </template>
                        </float-label>
                    </div>
                     <div class="col-lg-6 my-lg-3">
                        <float-label label="Fecha de Egreso:" clase="">
                            <input type="date" name="fechaEgreso" id="fechaEgreso" v-model="legajo.fecha_egreso" class="form-control">
                        </float-label>
                    </div>
                    <div class="col-lg-6">
                        <InpSelect url="situacionrevista" campoMostrar="descripcion" nombreLabel="Situacion de Revista" idSelect="SituacionRevista" :valor="legajo.situacion_revista_id" @val="legajo.situacion_revista_id=$event" :clase="(enviado && !$v.legajo.situacion_revista_id.required) ? 'is-invalid border border-danger' : ''"> 
                            <template v-slot:validation>
                                    <div class="invalid-feedback" v-if="enviado && !$v.legajo.situacion_revista_id.required">
                                        Debe ingresar una Situacion
                                    </div>
                            </template>
                        </InpSelect>
                    </div>
                    <div class="col-lg-6">
                        <float-label label="Lugar de trabajo:" clase="">
                            <input type="text" name="lugarTrabajo" id="lugarTrabajo" v-model="legajo.lugar_trabajo" placeholder="Lugar de trabajo" class="form-control" :class="(enviado && !$v.legajo.lugar_trabajo.required) ? 'is-invalid' : ''">
                            <template v-slot:validation>
                                <div class="invalid-feedback" v-if="enviado && !$v.legajo.lugar_trabajo.required">
                                    Debe ingresar un lugar de trabajo
                                </div>
                            </template>
                        </float-label>
                    </div>
                    <div class="col-lg-6">
                        <float-label label="Lugar de pago:" clase="">
                            <select name="clase" id="lugarPago" v-model="legajo.lugar_pago" class="form-control" :class="(enviado && !$v.legajo.lugar_pago.required) ? 'is-invalid' : ''">
                                <option value=null selected>Seleccione...</option>
                                                        <option value="Santa Rosa" selected>Santa Rosa</option>
                                                        <option value="General Acha">General Acha</option>
                                                        <option value="General Pico">General Pico</option>
                                                        <option value="Victorica">Victorica</option>
                                                        <option value="Realicó">Realicó</option>
                            </select>
                            <template v-slot:validation>
                                    <div class="invalid-feedback" v-if="enviado && !$v.legajo.lugar_pago.required">
                                        Debe ingresar un lugar de Pago
                                    </div>
                            </template>
                        </float-label>
                    </div>
                    <div class="col-lg-6">
                        <div class="row no-gutters">
                            <div class="col-6 row no-gutters justify-content-center">
                                <label for="">Discapacidad: </label>
                                <input type="checkbox" name="discapacidad" id="discapacidad" class="ml-2" v-model="legajo.discapacidad">
                            </div>
                            <div class="col-6 row no-gutters justify-content-center">
                                <label for="">Personal Temporario: </label>
                                <input type="checkbox" name="personalTemporario" id="personalTemporario" class="ml-2" v-model="legajo.personal_temporario">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <div class="main-card mb-3 card">
            <div class="card-body">
                <h5 class="border-bottom"><i class="fas fas fa-file-alt btn-icon-wrapper btn-icon-sm mb-2"></i> Datos de Liquidacion</h5>
                <div class="row pt-3">
                    <div class="col-lg-6">
                        <float-label label="Forma pago:" clase="">
                            <select name="formaPago" id="formaPago" v-model="legajo.forma_pago" class="form-control" :class="(enviado && !$v.legajo.forma_pago.required) ? 'is-invalid border border-danger rounded' : ''">
                                 <option value=null>Seleccione...</option>
                                <option value="Efectivo">Efectivo</option>
                                <option value="Dep. Bancario">Dep. Bancario</option>
                                <option value="Cheque">Cheque</option>
                            </select>
                            <template v-slot:validation>
                                    <div class="invalid-feedback" v-if="enviado && !$v.legajo.forma_pago.required">
                                        Debe ingresar una forma de pago
                                    </div>
                            </template>
                        </float-label>
                    </div>
                    <div class="col-lg-6">
                        <InpSelect url="sindicatos" campoMostrar="descripcion" nombreLabel="Sindicato" idSelect="Sindicato" :valor="legajo.sindicato_id" @val="legajo.sindicato_id=$event" :clase="(enviado && !$v.legajo.sindicato_id.required) ? 'is-invalid border border-danger' : ''"> 
                            <template v-slot:validation>
                                    <div class="invalid-feedback" v-if="enviado && !$v.legajo.sindicato_id.required">
                                        Debe ingresar un Sindicato
                                    </div>
                            </template>
                        </InpSelect>
                    </div>
                    <div class="col-lg-6">
                        <InpSelect url="obrasocial" nombreLabel="Obra Social" campoMostrar="descripcion" idSelect="obraSocial" :valor="legajo.obra_social_id" @val="legajo.obra_social_id=$event" :clase="(enviado && !$v.legajo.obra_social_id.required) ? 'is-invalid border border-danger' : ''">
                            <template v-slot:validation>
                                <div class="invalid-feedback" v-if="enviado && !$v.legajo.obra_social_id.required">
                                    Debe ingresar una obra Social
                                </div>
                            </template>
                        </InpSelect>
                    </div> 
                    <div class="col-lg-6">
                        <InpSelect url="regimenjubilatorio" nombreLabel="Regimen Jubilatorio" campoMostrar="descripcion" idSelect="regimenJubilatorio" :valor="legajo.regimen_jubilatorio_id" @val="legajo.regimen_jubilatorio_id=$event" :clase="(enviado && !$v.legajo.regimen_jubilatorio_id.required) ? 'is-invalid border border-danger' : ''">
                            <template v-slot:validation>
                                <div class="invalid-feedback" v-if="enviado && !$v.legajo.regimen_jubilatorio_id.required">
                                    Debe ingresar un Regimen
                                </div>
                            </template>
                        </InpSelect>
                    </div>
                    <div class="col-lg-6">
                        <InpSelect url="modalidadcontratacion" nombreLabel="Modalidad Contratacion" campoMostrar="descripcion" idSelect="modalidadContratacion" :valor="legajo.modalidad_contratacion_id" @val="legajo.modalidad_contratacion_id=$event" :clase="(enviado && !$v.legajo.modalidad_contratacion_id.required) ? 'is-invalid border border-danger' : ''">
                            <template v-slot:validation>
                                <div class="invalid-feedback" v-if="enviado && !$v.legajo.modalidad_contratacion_id.required">
                                    Debe ingresar una Modalidad Contratacion
                                </div>
                            </template>
                        </InpSelect>
                    </div>
                    <div class="col-lg-6">
                        <float-label label="Banco:" clase="">
                            <input type="text" v-model="legajo.banco" class="form-control" :class="(enviado && !$v.legajo.banco.required) ? 'is-invalid border border-danger rounded' : ''">
                            <template v-slot:validation>
                                    <div class="invalid-feedback" v-if="enviado && !$v.legajo.forma_pago.required">
                                        Debe ingresar una Banco
                                    </div>
                            </template>
                        </float-label>
                    </div>
                </div>
            </div>
          </div>
          <div class="col-lg-12">
            <button @click="guardarLegajo()" class="mt-1 btn btn-info float-right">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required, numeric } from "vuelidate/lib/validators";
import axios from "axios";
import Swal from "sweetalert2";
import Legajo from "@/models/legajo";
import Persona from '@/models/persona';
import InpSelect from '@/components/layouts/Select';
import ModalSeleccionarPersona from '@/components/views/personas/ModalSeleccionarPersona'
import '@/assets/css/chekbox.css';
export default {
  name: "EditarLegajo",
  components: {
    TituloComponent,
    FloatLabel,
    InpSelect,
    ModalSeleccionarPersona
  },
  data() {
    return {
            legajo: new Legajo(null, //id
                                null, //nbumero
                                null,//institucion
                                null, //persona
                                null, //categoria
                                null, //seccion
                                null,//cargo
                                'Mensual', //clase
                                false,//personal temporario
                                false, //discapacidad
                                null, //situaciond e revista
                                null, //fecha ingreso
                                null, //sindicato
                                null, //regimen jubilatorio
                                null, //obra social
                                null,   //modalidad contratacion
                                "Dep. Bancario", //forma pago
                                'Banco La Pampa', //banco
                                null,//lugar de trabajo
                                null,//lugar de pago
                                false),
        persona: new Persona(null, null, null, null, null, null, null, null, null, null, null, null),
        loading: false,
        enviado: false,
        institucion: JSON.parse(localStorage.getItem('institucion')),
        abrirSeleccionarPersona: false,
    };
  },
  validations: {
        legajo: {
            numero: { required, numeric },
            persona_id: { required },
            categoria_id: { required },
            seccion_id: { required },
            cargo_id: { required },
            clase: { required },
            personal_temporario: { required },
            discapacidad: { required },
            situacion_revista_id: { required },
            fecha_ingreso: { required },
            sindicato_id: { required },
            regimen_jubilatorio_id: { required },
            obra_social_id: { required },
            modalidad_contratacion_id: { required },
            forma_pago: { required },
            banco: { required },
            lugar_trabajo: { required },
            lugar_pago: { required },
        },
  },
  mounted() {
    this.legajo.id = this.$route.params.id;
    this.getLegajo();
  },
  methods: {
    abrirModalPersona(){
        this.abrirSeleccionarPersona = true;
    },
    seleccionPersona(persona){
      this.abrirSeleccionarPersona = false;
      this.persona = persona;
    },
    getLegajo() {
      this.loading = true;
      axios
        .get("legajos/" + this.legajo.id)
        .then((res) => {
          console.log(res.data);
          if (res.data.success) {
            console.log(res.data)
            this.legajo = res.data.legajo;
            this.persona = res.data.persona;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado Legajos.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarLegajo() {
        console.log(this.legajo)
        this.enviado = true;
        this.loading = true;
        this.$v.$touch();
        if(!this.persona.id){
            document.querySelector(".divPersona").focus();
           // $(".divPersona").focus();
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Debe seleccionar una persona, a la que le corresponde el legajo.',
            }).then(()=>{
                this.abrirModalPersona();
            })
        }
        this.legajo.persona_id = this.persona.id;
        if (this.$v.$invalid) {
            this.loading = false;
            return false;
        }
        axios
            .put("/legajos/" + this.legajo.id, this.legajo)
            .then((res) => {
            if (res.data.success) {
                Swal.fire({
                icon: "success",
                title: "Éxito",
                text: `${res.data.legajo.numero} se editó con éxito.`,
                });
                this.$router.push({ name: "ListarLegajos" });
            }
            })
            .catch((error) => {
            console.log(error);
            Swal.fire({
                icon: "error",
                title: "Oopss..",
                text: `No se ha podido completar la operación.`,
            });
            })
            .finally(() => (this.loading = false));
    },
  },
};
</script>
